// this script finds images tagged with having black bars.
// it crops the black bars and replaces the image with the cropped version.
// it uses IndexedDB to cache the cropped version for future use, so the expensive cropping operation only happens once per unique image URL.

window.addEventListener('load', () => {
    const elements = document.querySelectorAll<HTMLImageElement>('img.img-strip-black-bars');

    // Helper to open/setup the database
    async function getDB() {
        return new Promise<IDBDatabase>((resolve, reject) => {
            const request = indexedDB.open("ImageCacheDBTwo", 1);
            request.onupgradeneeded = (e) => {
                const db = (e.target as any).result as IDBDatabase;
                db.createObjectStore("images");
            };
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject("IndexedDB failed");
        });
    }

// Function to save to cache
    async function saveToCache(url, base64) {
        const db = await getDB();
        const tx = db.transaction("images", "readwrite");
        tx.objectStore("images").put(base64, url);
        return tx.oncomplete;
    }

// Function to get from cache
    async function getFromCache(url) {
        const db = await getDB();
        return new Promise((resolve) => {
            const request = db.transaction("images").objectStore("images").get(url);
            request.onsuccess = () => resolve(request.result);
        });
    }

// The "Smart" Wrapper
    async function getCroppedImage(url) : Promise<string>{
        // 1. Check Cache first
        const cached = await getFromCache(url);
        if (cached) {
            return cached;
        }

        // 2. If not in cache, run the expensive processing
        const processedBase64 = await cropBlackEdges(url); // Using the function from the previous message

        // 3. Save it for next time
        await saveToCache(url, processedBase64);

        return processedBase64;
    }

    async function cropBlackEdges(imageUrl) {
        return new Promise<string>((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous"; // Prevent CORS issues
            img.src = imageUrl;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d', { willReadFrequently: true });

                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;

                let top = 0, bottom = canvas.height, left = 0, right = canvas.width;

                // Helper to check if a pixel is NOT black (threshold added for compression artifacts)
                const isNotBlack = (x, y) => {
                    const i = (y * canvas.width + x) * 4;
                    const threshold = 50; // Adjust if "black" isn't perfectly #000000
                    return data[i] > threshold || data[i + 1] > threshold || data[i + 2] > threshold;
                };

                // Find Top boundary
                scanTop: for (let y = 0; y < canvas.height; y++) {
                    for (let x = 0; x < canvas.width; x++) {
                        if (isNotBlack(x, y)) { top = y; break scanTop; }
                    }
                }

                // Find Bottom boundary
                scanBottom: for (let y = canvas.height - 1; y >= 0; y--) {
                    for (let x = 0; x < canvas.width; x++) {
                        if (isNotBlack(x, y)) { bottom = y; break scanBottom; }
                    }
                }

                // Find Left boundary
                scanLeft: for (let x = 0; x < canvas.width; x++) {
                    for (let y = top; y <= bottom; y++) {
                        if (isNotBlack(x, y)) { left = x; break scanLeft; }
                    }
                }

                // Find Right boundary
                scanRight: for (let x = canvas.width - 1; x >= 0; x--) {
                    for (let y = top; y <= bottom; y++) {
                        if (isNotBlack(x, y)) { right = x; break scanRight; }
                    }
                }

                const width = right - left + 1;
                const height = bottom - top + 1;

                // Create a new canvas for the cropped result
                const trimmedCanvas = document.createElement('canvas');
                trimmedCanvas.width = width;
                trimmedCanvas.height = height;
                const trimmedCtx = trimmedCanvas.getContext('2d');

                // Draw the specific region from the original canvas
                trimmedCtx.drawImage(canvas, left, top, width, height, 0, 0, width, height);

                resolve(trimmedCanvas.toDataURL("image/png"));

                // cleanup canvas
                canvas.remove()
            };

            img.onerror = (err) => reject("Failed to load image: " + err);
        });
    }


    elements.forEach((img) => {
        const url = img.getAttribute('src');
        console.log("Cropping image:", url);
        getCroppedImage(url).then((croppedUrl) => {
            img.setAttribute('src', croppedUrl);
        }).catch((err) => {
            console.error("Error cropping image:", err);
        });
    });
});
